/** Which pictogram stands for a machine when it has no photo. The club's own data decides first (the machine's type code); then generic words of its make and model (in French and English,
 *  and the names of common machine families); then its kind. Pure, no I/O. A wrong guess is only a picture: the machine's photo replaces it, and the club's type corrects it. */
export interface AssetLookInput { kind?: string | null; asset_type_code?: string | null; make?: string | null; model?: string | null }

const RULES: Array<[picto: string, words: RegExp]> = [
  ['bunker_rake', /bunker|sand ?pro|rateau|raking/],
  ['top_dresser', /sabl|dress|epand|spread/],
  ['sprayer', /pulv|spray|multi ?pro|traitement/],
  ['aerator', /aer|procore|verti|scarif|carott|decompact|spike/],
  ['blower', /souffl|blow|buffalo/],
  ['greens_mower', /green|triplex|tees?\b/],
  ['fairway_mower', /fairway|reelmaster|cylindr|helicoid|gang/],
  ['trim_mower', /abord|rough|surround|trim ?cut|groundsmaster|rotati|rotary|deck/],
  ['tractor', /tract/],
  ['utility', /gator|xuv|xpx|workman|utilit|vehicul|vehicle|cart\b|pick ?up/],
  ['excavator', /pelle|excav|jcb|digger/],
  ['loader', /kramer|chargeu|loader|telesco|manitou/],
  ['trimmer', /debrous|strimmer|trimmer|taille ?haie|hedge/],
  ['fuel', /cuve|fuel|carbur|gasoil/],
  ['mower', /tond|mow/],
]
const BY_KIND: Record<string, string> = { machine: 'mower', vehicle: 'utility', attachment: 'attachment', tool: 'tool', component: 'component', fixed_asset: 'fixed' }
const plain = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export function pictoForAsset(a: AssetLookInput): string {
  const typed = plain((a.asset_type_code ?? '').replace(/_/g, ' '))
  for (const [picto, words] of RULES) if (typed && words.test(typed)) return picto
  const text = plain(`${a.make ?? ''} ${a.model ?? ''}`)
  for (const [picto, words] of RULES) if (words.test(text)) return picto
  return BY_KIND[a.kind ?? ''] ?? 'mower'
}

/** The machine's portrait: the newest photo linked to it with the purpose 'photo' (hidden ones are not shown). */
export interface PortraitLink { id: string; entity_type: string; entity_id: string; purpose: string; captured_at: string | null; hidden_at: string | null }
export function portraitsByAsset<L extends PortraitLink>(links: readonly L[]): Map<string, L> {
  const out = new Map<string, L>()
  for (const l of links) {
    if (l.entity_type !== 'fleet.asset' || l.purpose !== 'photo' || l.hidden_at) continue
    const have = out.get(l.entity_id)
    if (!have || (l.captured_at ?? '') > (have.captured_at ?? '') || ((l.captured_at ?? '') === (have.captured_at ?? '') && l.id > have.id)) out.set(l.entity_id, l)
  }
  return out
}
